import { render, staticRenderFns } from "./indinsight.html?vue&type=template&id=99ed5f20&scoped=true&external"
import script from "./indinsight.vue?vue&type=script&lang=ts"
export * from "./indinsight.vue?vue&type=script&lang=ts"
import style0 from "./indinsight.scss?vue&type=style&index=0&id=99ed5f20&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ed5f20",
  null
  
)

export default component.exports